import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Seo } from "@/components/layout/Seo";
import { LogoMark } from "@/components/brand/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-ink px-5">
      <Seo title="Admin Login | VION Tech" description="VION Tech admin area." noindex />
      <form onSubmit={submit} className="relative z-[2] w-full max-w-md rounded-[24px] bg-ivory p-8 sm:p-10" data-testid="admin-login-form">
        <LogoMark className="h-11 w-11" />
        <h1 className="mt-6 font-display text-3xl font-light text-ink">Admin sign in</h1>
        <p className="mt-2 text-sm text-ink/60">Manage VION Tech enquiries.</p>
        <div className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-ink/70">Email</Label>
            <Input id="admin-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 bg-white text-[16px] text-ink" data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-ink/70">Password</Label>
            <Input id="admin-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 bg-white text-[16px] text-ink" data-testid="login-password-input" />
          </div>
        </div>
        {error && <p className="mt-4 text-sm text-red-700" role="alert" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="mt-8 inline-flex min-h-[50px] w-full items-center justify-center gap-2 rounded-full bg-plum text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-plum-2 disabled:opacity-60" data-testid="login-submit-button">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
